import * as yup from 'yup';


import {distributionFormConstants} from '../DistributionForm';


export const SCHEMA_DISTRIBUTIONS = yup.array(distributionFormConstants.SCHEMA_DISTRIBUTION)
    .min(1)
    .required()
    .default(
        [
            distributionFormConstants.SCHEMA_DISTRIBUTION.getDefaultFromShape()
        ]
    );
